import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export function MemberSortHeader({ field, label, testId, sortBy, sortDir, onSort }: {
  field: string;
  label: string;
  testId: string;
  sortBy: string;
  sortDir: "asc" | "desc";
  onSort: (field: string) => void;
}) {
  const active = sortBy === field;
  const Icon = active ? sortDir === "asc" ? ArrowUp : ArrowDown : ArrowUpDown;
  return (
    <th scope="col" aria-sort={active ? sortDir === "asc" ? "ascending" : "descending" : undefined}
      className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
      <button type="button" className="flex items-center gap-1 hover:text-gray-800"
        onClick={() => onSort(field)} data-testid={testId}>
        {label} <Icon className="h-3 w-3" aria-hidden="true" />
      </button>
    </th>
  );
}
